<template>
  <div class="application-layout">
    <app-header />

    <app-main :width-full-width="$route?.meta?.layout?.widthFullWidth">
      <slot v-if="$session.isAuthenticated" />
    </app-main>

    <app-sidebar />

    <app-modal />

    <use-terms-banner-modal v-if="$session.isAuthenticated" />
  </div>
</template>

<script setup>
import { onMounted, watch } from 'vue';
import {
  AppHeader,
  AppMain,
  AppSidebar,
  AppModal,
} from '@components/app';
import { UseTermsBannerModal } from '@modules/terms';
import { useSession, useTermsBannerStore } from '@stores';
import { useRoute } from 'vue-router';

const $route = useRoute();
const $session = useSession();
const $termsBannerStore = useTermsBannerStore();

const triggerFetch = () => {
  if ($session.isAuthenticated) $termsBannerStore.fetch();
};

onMounted(triggerFetch);

watch(() => $session.isAuthenticated, (value) => {
  if (value) triggerFetch();
});
</script>

<style lang="scss">
.application-layout {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;

  @media print {
    height: auto;
  }
}
</style>
